import React from "react";
import "./TermsAndConditions.css";
import ScrollToTop from "../../components/ScrollToTop/ScrollTopTop";

function TermsAndConditions() {
  return (
    <>
      <section id="terms_policy">
        <div className="terms_wrapper container">
          <p className="p_head">Terms and Conditions</p>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipisicing elit. A dolorum
            quae asperiores blanditiis quo consequatur incidunt, labore
            voluptatem molestias cum quibusdam sequi quia numquam voluptatum
            quos? Neque incidunt iure asperiores.
          </p>
          <p className="p_sub_head">1. Use of Services</p>
          <p>
            Our services include counseling, youth groups, kids services, and
            donations. You must use our services only for lawful purposes and in
            a manner that does not violate any applicable laws or regulations.
            You may not use our services to harass, harm, or otherwise infringe
            upon the rights of others.
          </p>
          <p className="p_sub_head">2. Content</p>
          <p>
            The content on our website, social media platforms, and other
            materials related to our services is provided for informational
            purposes only. We do not guarantee the accuracy, completeness, or
            usefulness of any content, and we are not responsible for any errors
            or omissions. You rely on any content at your own risk.
          </p>
          <p className="p_sub_head">3. Donations</p>
          <p>
            Donations to Highway of Holiness Church are voluntary and
            non-refundable. You are responsible for ensuring that the
            information you provide when making a donation is accurate and
            up-to-date.
          </p>
          <p className="p_sub_head">4. Limitation of Liability</p>
          <p>
            Highway of Holiness Church is not liable for any damages or losses
            that may arise from your use of our services, including but not
            limited to direct, indirect, incidental, consequential, or punitive
            damages. We are not liable for any damages or losses resulting from
            any errors, omissions, or interruptions in our services.
          </p>
          <p className="p_sub_head">4. Indemnification</p>
          <p>
            You agree to indemnify and hold Highway of Holiness Church harmless
            from any and all claims, damages, expenses, or losses arising from
            your use of our services or your violation of these terms and
            conditions.
          </p>
          <p className="p_sub_head">6. Intellectual Property</p>
          <p>
            All content on our website and social media platforms is protected
            by copyright, trademark, and other intellectual property laws. You
            may not use our content without our prior written permission.
          </p>
          <p className="p_sub_head">7. Governing Law</p>
          <p>
            These terms and conditions are governed by and construed in
            accordance with the laws of the jurisdiction in which Highway of
            Holiness Church is located.
          </p>
          <p className="p_sub_head">8. Governing Law</p>
          <p>
            These terms and conditions are governed by and construed in
            accordance with the laws of the jurisdiction in which Highway of
            Holiness Church is located.
          </p>
          <p className="p_sub_head">9. Severability</p>
          <p>
            If any provision of these terms and conditions is found to be
            invalid or unenforceable, the remaining provisions will remain in
            full force and effect.
          </p>
        </div>
      </section>
      <ScrollToTop />
    </>
  );
}

export default TermsAndConditions;
